import { circIn } from "motion";
import { motion } from "motion/react";

const Experience = () => {
  return (
    <div className="flex gap-x-6 mt-16">
      <div className="w-full p-0.5 bg-gradient-to-b from-[#272727] to-[#111111] rounded-[40px]">
        <div
          initial={{ scale: 0 }}
          animate={{ transition: { duration: 0.4, timing: circIn }, scale: 1 }}
          className=" items-center w-full bg-[#0D0D0D] rounded-[40px] text-white p-14"
        >
          <div className="text-5xl ">
            My
            <p className="pacifico-regular inline"> background</p>
          </div>
          <p className="text-lg mt-8 text-[#9CA3AF] tracking-wider">
            I am a passionate and results-driven frontend developer with over
            3.5 years of experience creating responsive, user-friendly, and
            visually appealing web applications. My expertise lies in
            transforming ideas into seamless digital experiences using modern
            frontend technologies.
          </p>
          <div className="flex items-center justify-between w-full mt-8">
            <div className="">
              <div className="flex">
                <p className="text-lg text-white tracking-wider font-medium">
                  DocMx (it4Australia pty ltd)
                </p>
                <a
                  href="https://au.linkedin.com/company/doc-mx"
                  target="_blank"
                >
                  <i className="bi bi-linkedin text-white text-lg mx-2"></i>
                </a>
              </div>
              <p className="text-sm text-[#9CA3AF] tracking-wider">
                Frontend Development Engineer
              </p>
            </div>
            <div className="h-[1px] bg-[#1f2937] flex-grow-[1] mx-5"></div>

            <div className="text-sm text-right">Nov 2023 - Present</div>
          </div>

          <div className="flex items-center justify-between w-full mt-8">
            <div className="">
              <div className="flex">
                <p className="text-lg text-white tracking-wider font-medium">
                  TCS
                </p>
                <a
                  href="https://in.linkedin.com/company/tata-consultancy-services"
                  target="_blank"
                >
                  <i className="bi bi-linkedin text-white text-lg mx-2"></i>
                </a>
              </div>
              <p className="text-sm text-[#9CA3AF] tracking-wider">
                Programmer
              </p>
            </div>
            <div className="h-[1px] bg-[#1f2937] flex-grow-[1] mx-5"></div>

            <div className=" text-sm text-right">Oct 2021 - Sept 2023</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
